/**
 * feature-config flag names owned by collaboration
 *
 * please consider removing this file and adding it to an appropriate place in the
 * feature code (e.g. an entrypoint, or a package owned by the feature team), or
 * passing flag names directly as a string!
 *
 * by separating it out, we decouple the feature code from the feature config packages
 * and avoid the need to update this package when flags are added or removed.
 */

export const COLLABORATION_FLAG_NAMES = {
  COMMENT_WEBHOOKS: 'ff-collab-5218-comment-webhooks',
  NODE_SYNC_LOCK: 'ff-collab-node-sync-lock',
  REALTIME: 'ff-collab-5170-realtime',
  SAFER_CONTENT_MODERATION: 'ff-dse-7177-safer-content-moderation',
  VERSION_ENFORCEMENT: 'ff-collab-5813-version-enforcement',
  MINI_TOOLBAR_NESTED_COMPONENTS: 'ff-col-6563-mini-toolbar-nested-components',
  LOG_COMPONENT_INSTANCE_COUNT_DIFF:
    'ff-col-6815-log-component-instance-count-diff',
  LEGACY_EDITOR_MIGRATION_FTU: 'ff-col-7036-legacy-editor-migration-ftu',
  LE_DEPRECATION_ANNOUNCEMENT: 'ff-col-7045-le-deprecation-announcement',
  TRIGGER_SURVEY_ON_OWNERSHIP: 'ff-col-7118-trigger-survey-on-ownership',
};
